import { Box, Group } from "@mantine/core"
import styles from "./BoxRadio.module.css"

export interface BoxRadioOption {
	value: string
	label: string
}

export interface BoxRadioProps {
	options: BoxRadioOption[]
	value?: string
	defaultValue?: string
	onChange?: (value: string) => void
	legend?: string
	fieldsetClassName?: string
	legendClassName?: string
}

export function BoxRadio({
	options,
	value,
	defaultValue,
	onChange,
	legend,
	fieldsetClassName,
	legendClassName
}: BoxRadioProps) {
	const handleChange = (optionValue: string) => {
		if (onChange) {
			onChange(optionValue)
		}
	}

	const radioGroup = (
		<Group gap={8} w={"100%"} className={styles.radioGroup} role="radiogroup">
			{options.map((option) => (
				<Box
					key={option.value}
					className={`${styles.radioBox} ${(value || defaultValue) === option.value ? styles.selected : ""}`}
					onClick={() => handleChange(option.value)}
					role="radio"
					aria-checked={(value || defaultValue) === option.value}
				>
					<input
						type="radio"
						name="box-radio-group"
						value={option.value}
						checked={(value || defaultValue) === option.value}
						onChange={() => handleChange(option.value)}
						className={styles.hiddenInput}
						aria-label={option.label}
					/>
					{option.label}
				</Box>
			))}
		</Group>
	)

	if (legend) {
		return (
			<fieldset className={`${styles.fieldset} ${fieldsetClassName || ""}`}>
				<legend className={`${styles.legend} ${legendClassName || ""}`}>
					{legend}
				</legend>
				{radioGroup}
			</fieldset>
		)
	}

	return radioGroup
}

export default BoxRadio
